module.exports = __webpack_public_path__ + "static/img/performance04.6ce7f007.jpg";